var map = {
	"./pin-art-center.png": 136,
	"./pin-fu-shin-street.png": 137,
	"./pin-green-hub.png": 138,
	"./pin-hong-kong-railway-museum.png": 139,
	"./pin-kwong-fuk-bridge.png": 140,
	"./pin-man-mou-temple.png": 141,
	"./pin-old-district-office.png": 142,
	"./pin-old-hostel.png": 143,
	"./pin-sam-man-tsai.png": 144,
	"./pin-shuen-wan-typhoon-shelter.png": 145,
	"./pin-tai-po-geoheritage-centre.png": 146,
	"./pin-the-lane-square-in-tai-po.png": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;